/* eslint-disable react/no-array-index-key */
import React from 'react';
import { useStoreMap } from 'effector-react';
import { $tourData, $tourDataApi } from '@stores/dataStores';
import CustomButtonSetting from '@components/CustomButtonSetting';

function SidebarCustomButton() {
  const customButton = useStoreMap({
    store: $tourData,
    keys: [],
    fn: (state) => state.customButton ?? [],
  });
  return (
    <CustomButtonSetting
      value={customButton}
      onChange={(val) => {
        $tourDataApi.update((draft) => {
          draft.customButton = val;
        });
      }}
    />
  );
}

export default SidebarCustomButton;
